import ToursHostScreen from '../(tabs)/tours/host'
import { seedToursHost } from '../../preview/seed'
import { PreviewSeedBoundary } from '../../preview/PreviewSeedBoundary'

export default function PreviewHostRoute() {
  return (
    <PreviewSeedBoundary seed={seedToursHost} seedKey="host">
      <ToursHostScreen />
    </PreviewSeedBoundary>
  )
}
